/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archon_Import_SuccessInputs */



/**
* | output |
* | --- |
* | "Archon import successful" |
*
* @param {Archon_Import_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archon_import_success = /** @type {((inputs?: Archon_Import_SuccessInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archon_Import_SuccessInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Import Archon réussi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de Archon correcta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Importação do Archon concluída")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione Archon riuscita")
	return /** @type {LocalizedString} */ ("Archon import successful")
});